import { createContext } from "react";

export const BaseUrl = createContext();